export default "__VITE_ASSET__Bsphm0JP__"